"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileMoney = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
class MobileMoney {
}
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", String)
], MobileMoney.prototype, "POS_TID", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", String)
], MobileMoney.prototype, "POS_key", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", String)
], MobileMoney.prototype, "hostname", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: "decimal", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], MobileMoney.prototype, "cashlessAtmIncrement", void 0);
exports.MobileMoney = MobileMoney;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW9iaWxlTW9uZXkuanMiLCJzb3VyY2VSb290IjoiLi9zcmMvIiwic291cmNlcyI6WyJwYWNrYWdlcy9tb2RlbHMvc3JjL21vYmlsZU1vbmV5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7QUFBQSxxQ0FBaUM7QUFFakMsTUFBYSxXQUFXO0NBU3ZCO0FBUkc7SUFBQyxJQUFBLGdCQUFNLEVBQUMsRUFBRSxRQUFRLEVBQUUsSUFBSSxFQUFFLENBQUM7OzRDQUNWO0FBQ2pCO0lBQUMsSUFBQSxnQkFBTSxFQUFDLEVBQUUsUUFBUSxFQUFFLElBQUksRUFBRSxDQUFDOzs0Q0FDVjtBQUNqQjtJQUFDLElBQUEsZ0JBQU0sRUFBQyxFQUFFLFFBQVEsRUFBRSxJQUFJLEVBQUUsQ0FBQzs7NkNBQ1Q7QUFDbEI7SUFBQyxJQUFBLGdCQUFNLEVBQUMsRUFBRSxJQUFJLEVBQUUsU0FBUyxFQUFFLFFBQVEsRUFBRSxJQUFJLEVBQUUsQ0FBQzs7eURBQ2Q7QUFSbEMsa0NBU0MiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBDb2x1bW4gfSBmcm9tIFwidHlwZW9ybVwiO1xuXG5leHBvcnQgY2xhc3MgTW9iaWxlTW9uZXkge1xuICAgIEBDb2x1bW4oeyBudWxsYWJsZTogdHJ1ZSB9KVxuICAgIFBPU19USUQ/OiBzdHJpbmc7XG4gICAgQENvbHVtbih7IG51bGxhYmxlOiB0cnVlIH0pXG4gICAgUE9TX2tleT86IHN0cmluZztcbiAgICBAQ29sdW1uKHsgbnVsbGFibGU6IHRydWUgfSlcbiAgICBob3N0bmFtZT86IHN0cmluZztcbiAgICBAQ29sdW1uKHsgdHlwZTogXCJkZWNpbWFsXCIsIG51bGxhYmxlOiB0cnVlIH0pXG4gICAgY2FzaGxlc3NBdG1JbmNyZW1lbnQ/OiBudW1iZXI7XG59XG4iXX0=